import { WFEWorkflowItemRawDto } from '../../workflow/_models/workflow-data-entry/wfe-workflow-item-raw-dto';
import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../_constants/validation-format-constants';

export class WFEWorkflowRawDto {
    workflowId: number;
    status: string;
    communityId: number;
    payeeType: string;
    payeeCode: string;
    vendorAccountId: number;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    invoiceDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    dueDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    postDate: Date;

    description: string;
    invoiceAmount: number;
    amount: number;
    invoiceNumber: string;
    specialHandlingId: number;
    lateFee: number;
    vendorBillToNotMatch: boolean;
    vendorRemitToNotMatch: boolean;
    isEFTAccount: boolean;

    bankAccountId: number;
    apBillId: number;

    @Type(() => WFEWorkflowItemRawDto)
    items: Array<WFEWorkflowItemRawDto>; // AAP Workflow line items

    allowProcessing: boolean;
    allowReplaceInvoice: boolean;
    allowWorkQueueTransfer: boolean;
    allowDelete: boolean;
    allowSendToSupervisor: boolean;
    hasNotes: boolean;
    specialInstruction: string;

    boardApprovalRequired: boolean;
}
